import React from "react";
import PropTypes from "prop-types";
import { VstPopover, VstInput, VstButton } from "vstui";
import Isvg from "../../../../vendor/react-inlinesvg";
import Dispatcher from "../../../dispatcher";
import OverleafStore, { TYPE_TEXT } from "../../../stores/overleaf-store";

class DeckList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      decks: [],
      title: "",
      loading: false,
      creating: false
    };

    this.onNewDeckClick = this.onNewDeckClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.openFlashCardsPanel = this.openFlashCardsPanel.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.createDeck = this.createDeck.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(Dispatcher.OVERLEAF_CHANGE, this.onStoreChange);
    this.onStoreChange();
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.OVERLEAF_CHANGE, this.onStoreChange);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
  }

  onStoreChange() {
    OverleafStore.getDecks({ isbn: this.props.isbn }).then(decks => {
      this.setState({ decks });
    });
  }

  onNewDeckClick() {
    this.props.onClick();
    this.setState({ creating: true });
  }

  onInputChange(e) {
    const { value, name } = e.currentTarget;
    this.setState({ [name]: value });
  }

  createDeck() {
    const deck = {
      title: this.state.title,
      metadata: { isbn: this.props.isbn }
    };
    this.setState({ loading: true });
    OverleafStore.createDeck(deck).then(deck => {
      this.setState({ creating: false, loading: false });
      this.openFlashCardsPanel(deck);
      this.props.closePopover();
    });
  }

  openFlashCardsPanel(deck) {
    const props = {
      deck,
      newCardFront: {
        content: this.props.selectedText,
        type: TYPE_TEXT,
        metadata: {}
      }
    };
    Dispatcher.emit(Dispatcher.SHOW_UNSEEN_PANEL, "flashcards", props);
    Dispatcher.emit(Dispatcher.FLASHCARD_CREATE_REQUEST, props);
    this.props.closePopover();
  }

  renderCreateDeck() {
    return (
      <div className="deck-create">
        <div className="title">{i18n.t("reader.flashcards.new-deck")}</div>

        <VstInput
          id="deck-name"
          placeholder={i18n.t("reader.flashcards.deck-name")}
          label={i18n.t("reader.flashcards.deck-name")}
          name="title"
          value={this.state.name}
          onChange={this.onInputChange}
        />
        <div className="actions">
          <VstButton onClick={this.createDeck} options="btn-32">
            {i18n.t("base.create")}
          </VstButton>
        </div>
      </div>
    );
  }

  renderDeckList() {
    const { decks } = this.state;
    if (decks.length) {
      return (
        <div className="deck-list">
          <div className="decks">
            <div className="title">
              {i18n.t("reader.flashcards.choose-deck")}
            </div>
            <ul>
              {decks.map(deck => (
                <li
                  key={`deck-list-${deck.uuid}`}
                  onClick={() => this.openFlashCardsPanel(deck)}
                >
                  <button>{deck.title}</button>
                </li>
              ))}
            </ul>
          </div>
          {this.renderNewDeckButton()}
        </div>
      );
    }

    return (
      <div className="empty-state">
        <div className="message">{i18n.t("reader.flashcards.create-deck")}</div>
        {this.renderNewDeckButton()}
      </div>
    );
  }

  renderNewDeckButton() {
    return (
      <div>
        <button className="new-deck noButton" onClick={this.onNewDeckClick}>
          <Isvg src="/img/circle_icon_lg_add.svg" />
          {i18n.t("reader.flashcards.new-deck")}
        </button>
      </div>
    );
  }
  render() {
    if (this.state.creating) {
      return this.renderCreateDeck();
    }
    return this.renderDeckList();
  }
}

DeckList.propTypes = {
  isbn: PropTypes.string.isRequired,
  selectedText: PropTypes.string,
  onClick: PropTypes.func,
  closePopover: PropTypes.func
};

DeckList.defaultProps = {
  selectedText: "",
  onClick: () => {},
  closePopover: () => {}
};

export default DeckList;
